import classNames from "classnames";
import PropType from "prop-types";
import { useTranslate } from "../../../language/i18n";

import { THEME } from "@myloc/myloc-gui";
import { useEffect, useState } from "react";
import { Car, Clock, Place, Room } from "../../../assets/icons";
import pages from "../../../utils/pages";
import CheckAuthButton from "../../shared/Buttons/CheckAuthButton";
import styles from "../FittingDetailPage.module.scss";
import AnnulFittingMeetingModal from "../Modals/AnnulFittingMeetingModal";

const annulled = "CANCELED";

const PreviousMeeting = ({ fitting, setBreadcrumbs, embeddedFitting, setFetchFittings }) => {
  const translate = useTranslate();
  const [modal, setModal] = useState("");
  const [meetingId, setMeetingId] = useState();
  const previousMeetings = fitting?.previousMeetings;
  const isCompleted = fitting?.status?.value === 90 || fitting?.status?.value === 99;

  useEffect(() => {
    setBreadcrumbs([
      {
        text: embeddedFitting?.text
          ? translate(embeddedFitting?.text)
          : `${translate(pages.MY_MYLOC.NAME)} - ${translate(pages.FITTINGS.NAME)}`,
        link: embeddedFitting?.path ? embeddedFitting?.path : pages.MY_FITTINGS.PATH,
      },
      {
        text: `${translate(pages.FITTING_DETAIL.NAME)} - ${translate(pages.MY_FITTINGS_PREVIOUS_MEETING.NAME)}`,
      },
    ]);
  }, [embeddedFitting, setBreadcrumbs, translate]);

  const openModal = meeting => {
    setMeetingId(meeting.id);
    setModal("ANNUL_MEETING");
  };

  const closeModal = () => {
    setMeetingId("");
    setModal("");
  };

  return (
    <section>
      <h3 className={styles.title}>{translate("FITTING_SUB_NAV_PREVIOUS_MEETINGS")}</h3>

      {previousMeetings?.length ? (
        <ul className={styles.meetingList}>
          {previousMeetings.map(meeting => (
            <li
              key={meeting.id}
              className={classNames(styles.meetingCard, meeting.status === annulled && styles.meetingCardAnnulled)}
            >
              <div className={styles.meetingHeader}>
                <div className={styles.meetingTime}>
                  <Clock customCssClass={styles.icon} />
                  {`${meeting.date || ""} ${meeting.fromTime || ""} – ${meeting.toTime || ""}`}
                </div>
                {meeting.status === annulled && <span className={styles.annulledBadge}>{translate("ANNULLED")}</span>}
              </div>

              <div className={styles.meetingBody}>
                <div>
                  <div className={styles.meetingInfo}>
                    <Place customCssClass={styles.icon} />
                    {`${meeting.address?.street || ""}, ${meeting.address?.postalNo || ""} ${
                      meeting.address?.city || ""
                    }`}
                  </div>
                  {meeting.room && (
                    <div className={styles.meetingInfo}>
                      <Room customCssClass={styles.icon} />
                      {meeting.room.label}
                    </div>
                  )}
                  {meeting.car && (
                    <div className={styles.meetingInfo}>
                      <Car customCssClass={styles.icon} />
                      {meeting.car.value}
                    </div>
                  )}
                </div>

                <div className={styles.participantsSection}>
                  {meeting.consultant?.firstName && (
                    <div className={styles.participant}>
                      <span className={styles.participantLabel}>{translate("CONSULTANT")}</span>
                      <div>
                        <div>{`${meeting.consultant.firstName ?? ""} ${meeting.consultant.surname ?? ""}`}</div>
                        {meeting.consultant.phoneNo && <div>{meeting.consultant.phoneNo}</div>}
                        {meeting.consultant.email && <div>{meeting.consultant.email}</div>}
                      </div>
                    </div>
                  )}
                  {meeting.technician?.firstName && (
                    <div className={styles.participant}>
                      <span className={styles.participantLabel}>{translate("TECHNICIAN")}</span>
                      <div>
                        <div>{`${meeting.technician.firstName ?? ""} ${meeting.technician.surname ?? ""}`}</div>
                        {meeting.technician.phoneNo && <div>{meeting.technician.phoneNo}</div>}
                        {meeting.technician.email && <div>{meeting.technician.email}</div>}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {!isCompleted && meeting.status !== annulled && (
                <div className={styles.meetingFooter}>
                  <CheckAuthButton
                    theme={THEME.PLAIN_PRIMARY}
                    onClick={() => openModal(meeting)}
                    title={translate("ANNUL_FITTING_MEETING")}
                    authId={"FSP_CancelWebOrderFittingMeeting"}
                  />
                </div>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <p>{translate("NO_MEETINGS")}</p>
      )}

      <AnnulFittingMeetingModal
        visible={modal === "ANNUL_MEETING"}
        fittingId={fitting.id}
        meetingId={meetingId}
        onClose={() => closeModal()}
        setFetchFittings={setFetchFittings}
      />
    </section>
  );
};

PreviousMeeting.propTypes = {
  fitting: PropType.object,
  setBreadcrumbs: PropType.func,
  embeddedFitting: PropType.object,
  setFetchFittings: PropType.func,
};

export default PreviousMeeting;
